import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders, umsUrl, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { REGISTRATION_BENEFIT, REGISTRATION_BENEFIT_SUCCESS, REGISTRATION_BENEFIT_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';

function* getRegistrationBenefit({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];
    const { clientId, programId, pageSize, pageIndex } = payload?.data;

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v1/client/${clientId}/projects/${programId}/benefits?pageSize=${pageSize}&pageIndex=${pageIndex}`,
      method: 'GET',
      headers: {
        // Authorization: Constant?.CLIENT_TOKEN,
        ...filteredHeaders,
        // withCredentials: true
      },
      params: payload?.urlParams,
    });

    if (response.status === 200) {
      yield put({
        type: REGISTRATION_BENEFIT_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: REGISTRATION_BENEFIT_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: REGISTRATION_BENEFIT_ERROR, payload: error });
  }
}

export function* watchRegistrationBenefit() {
  yield takeEvery(REGISTRATION_BENEFIT, getRegistrationBenefit);
}

function* watchRegistrationBenefitSaga() {
  yield all([fork(watchRegistrationBenefit)]);
}

export default watchRegistrationBenefitSaga;
